import { render, staticRenderFns } from "./ShirtOrder.vue?vue&type=template&id=07ab280e&scoped=true"
import script from "./ShirtOrder.vue?vue&type=script&lang=js"
export * from "./ShirtOrder.vue?vue&type=script&lang=js"
import style0 from "./ShirtOrder.vue?vue&type=style&index=0&id=07ab280e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ab280e",
  null
  
)

export default component.exports